import React from "react";

const Home = () => {
    return (
        <h1 className="font-extralight text-3xl">Über mich</h1>
    );
}

export default Home;